<template>
  <div class="funnel-result">
    <transition-group
      name="funnel-list"
      tag="div"
      v-bind:css="false"
      v-on:before-enter="funnelListBeforeEnter"
      v-on:enter="funnelListEnter">
      <div class="row m-0" data-key="'div-100'" :key="'div-100'">
        <div class="col col-sm-3"></div>
        <div class="col col-sm-7">
          <div class="block-wrapper">
            <div class="block block-all">
              <transition
                appear
                v-on:before-appear="funnelBeforeAppearHook"
                v-on:appear="funnelAppearHook"
                v-on:after-appear="funnelAfterAppearHook"
              >
                <div class="block-content">
                  <span class="block-content-value">100%</span>
                </div>
              </transition>
              <transition
                appear
                v-on:before-appear="spaceBeforeAppearHook"
                v-on:appear="spaceAppearHook"
              >
                <div class="block-space">
                  <em class="icon icon-arrow-down16"></em>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="col col-sm-2 no-intention-head">
          No intention
        </div>
      </div>
      <div class="row m-0"
          v-for="(layer, layerIndex) in funnelList"
          :data-index="layerIndex"
          :key="layer.testerId || 'layer-'+layerIndex">
        <div class="col col-sm-3">
          <div>
            <strong>{{layer.type}}: {{layer.name || layer.testerId}}</strong>
          </div>
          <small class="color-light-green">
            {{layer.total}} messages
          </small>
        </div>
        <div class="col col-sm-7">
          <transition-group
            name="funnel-percent"
            class="block-wrapper"
            tag="div"
            v-bind:css="false"
            v-on:before-appear="funnelPercentBeforeAppear"
            v-on:appear="funnelPercentAppear">
            <div v-if="layer.percentVal.previous > 0"
                class="block block-previous" :key="layer.testerId+'-prev'"
                :data-width="layer.percent.previous" :data-index="0">&nbsp;</div>
            <div v-if="layer.percentVal.negative > 0" class="block block-negative"
                :key="layer.testerId+'-neg'"
                :data-width="layer.percent.negative" :data-index="1">
              <div class="block-content">
                <span class="block-content-value">
                  {{layer.percent.negative}}
                </span>
              </div>
            </div>
            <div v-if="layer.percentVal.positive > 0" class="block block-positive"
                :key="layer.testerId+'-pos'"
                :data-width="layer.percent.positive" :data-index="2">
              <div class="block-content">
                <span class="block-content-value">
                  {{layer.percent.positive}}
                </span>
              </div>
            </div>
            <div v-if="layer.percentVal.none > 0" class="block block-none"
                :key="layer.testerId+'-none'"
                :data-width="layer.percent.none" :data-index="3">
              <transition
                appear
                v-on:before-appear="funnelBeforeAppearHook"
                v-on:appear="funnelAppearHook"
                v-on:after-appear="funnelAfterAppearHook"
              >
                <div class="block-content">
                  <span class="block-content-value">
                    {{layer.percent.none}}
                  </span>
                </div>
              </transition>
              <transition
                appear
                v-on:before-appear="spaceBeforeAppearHook"
                v-on:appear="spaceAppearHook"
              >
                <div class="block-space">
                  <em class="icon icon-arrow-down16"></em>
                </div>
              </transition>
            </div>
          </transition-group>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
/* eslint-disable */
import Velocity from 'velocity-animate/velocity.min';

export default {
  name: 'funnelResult',
  props: {
    funnels: Array,
    // totalMessages: Number,
  },
  watch: {
    funnels() {
      // TODO - Add to funnel list and animate
    },
  },
  data() {
    return {
      totalMessages: 0,
      dummyData: [{
        type: 'MODEL', testerId: '5cc1832b33bca8000119c038', actualTotal: 3, total: 4, positive: 2, negative: 1, negativeFromNone: 1, negativeFromPredict: 0, none: 1, precision: 1, accuracy: 0.75, f1Score: 0.8, recall: 0.67,
      }, {
        type: 'RULEBASED', testerId: '5cc182aa33bca8000119c036', actualTotal: 1, total: 1, positive: 1, negative: 0, negativeFromNone: 0, negativeFromPredict: 0, none: 0, precision: 1, accuracy: 1, f1Score: 1, recall: 1,
      }],
      funnelList: [],
    };
  },
  mounted() {
    this.funnelList = this.prepareFunnelData(this.dummyData);
  },
  methods: {
    prepareFunnelData(inputArr) {
      // Get previous total and width %
      const res = [];
      let prevTotal = 0;
      for (let i = 0; i < inputArr.length; i += 1) {
        const obj = inputArr[i];
        if (i === 0) {
          this.totalMessages = obj.total;
        }
        obj.prevTotal = prevTotal;
        // Set val and style width string
        const prevVal = ((obj.prevTotal / this.totalMessages) * 100).toFixed(0);
        const posVal = ((obj.positive / this.totalMessages) * 100).toFixed(0);
        const negVal = ((obj.negative / this.totalMessages) * 100).toFixed(0);
        const noneVal = ((obj.none / this.totalMessages) * 100).toFixed(0);
        obj.percent = {
          previous: `${prevVal}%`,
          positive: `${posVal}%`,
          negative: `${negVal}%`,
          none: `${noneVal}%`,
        };
        obj.percentVal = {
          previous: prevVal,
          positive: posVal,
          negative: negVal,
          none: noneVal,
        };
        res.push(obj);
        const currentTotal = obj.positive + obj.negative;
        prevTotal += currentTotal;
      }
      return res;
    },
    getValueElem(elem) {
      return elem.querySelector('.block-content-value');
    },
    funnelBeforeAppearHook(elem) {
      // console.log('CALL SpaceAppear', elem);
      const el = elem;
      el.style.width = 0;
      el.style.opacity = 0;
    },
    funnelAppearHook(elem, done) {
      // console.log('CALL FunnelAppear', elem);
      Velocity(
        elem,
        { width: '100%', opacity: 1 },
        {
          duration: 800, easing: 'easeInQuad', delay: 300, complete: done,
        },
      );
    },
    funnelAfterAppearHook(elem) {
      // console.log('CALL FunnelAfter', elem);
      const valueElem = this.getValueElem(elem);
      Velocity(valueElem, { color: '#fff' }, { duration: 500 });
    },
    spaceBeforeAppearHook(elem) {
      // console.log('CALL SpaceBefore', elem);
      const el = elem;
      el.style.height = 0;
      el.style.lineHeight = 0;
      el.style.color = '#fff';
    },
    spaceAppearHook(elem, done) {
      // console.log('CALL SpaceAppear', elem);
      Velocity(elem, {
        height: '40px',
        lineHeight: '40px',
        color: '#888',
      }, {
        duration: 1000,
        delay: 1100,
        queue: 'space',
        easing: 'easeInOutBack',
        complete: done,
      });
    },
    funnelListBeforeEnter(elem) {
      // console.log('CALL ListBefore', elem);
      const el = elem;
      el.style.opacity = 0;
    },
    funnelListEnter(elem, done) {
      // console.log('CALL ListEnter', elem);
      const layerIndex = parseInt(elem.getAttribute('data-index'), 10);
      const delay = layerIndex * 6000;
      setTimeout(() => {
        Velocity(elem, { opacity: 1 }, { duration: 500, complete: done });
      }, delay);
    },
    funnelPercentBeforeAppear(elem) {
      // console.log('CALL PercentBefore', elem);
      const el = elem;
      el.style.opacity = 0;
      el.style.width = 0;
    },
    funnelPercentAppear(elem, done) {
      // console.log('CALL PercentAppear', elem);
      const pcWidth = elem.getAttribute('data-width');
      const layerIndex = parseInt(elem.getAttribute('data-index'), 10);
      const delay = (layerIndex + 1) * 1000;
      if (pcWidth !== '0%') {
        setTimeout(() => {
          Velocity(elem, { opacity: 1, width: pcWidth }, { duration: 500, complete: done });
        }, delay);
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
  .funnel-result {
    .block-wrapper {
      display: flex;
      width: 100%;
      background-color: #ddd;
      padding: 0;
      .block {
        width: 100%;
      }
      .block-content {
        height: 40px;
        max-height: 40px;
        text-align: center;
        font-size: 12px;
        line-height: 40px;
        background-color: #ddd;
      }
      .block-space {
        height: 40px;
        max-height: 40px;
        text-align: center;
        background-color: white;
        border-right: 1px dashed #ddd;
        border-left: 1px dashed #ddd;
        color: #fff;
        line-height: 40px;
        font-size: 16px;
        overflow: hidden;
        .icon {
          color: inherit;
          font-size: inherit;
        }
      }
      .block-all {
        background-color: #ddd;
        .block-content {
          color: #0aa7ef;
          background-color: #0aa7ef;
        }
      }
      .block-positive .block-content {
        background-color: #44ada2;
      }
      .block-negative .block-content {
        background-color: #e16768;
      }
      .block-none .block-content {
        background-color: #888;
      }
    }
  }
</style>
